import React from 'react';
import { Button, Card, Popup, Icon } from 'semantic-ui-react';

function BalanceCard(props) {
  const { header, formattedAmount, withdrawalButtonText, tooltip } = props;

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          {header}
          <Popup
            size="tiny"
            inverted
            trigger={<Icon color="grey" className="universe-info" />}
            content={tooltip}
          />
        </Card.Header>
        <Card.Description>{formattedAmount}</Card.Description>
        {/* only show withdrawal button if there is money available */}
        {withdrawalButtonText && (
          <a href={`/withdrawals/new/${props.currency}`}>
            <Button primary>{withdrawalButtonText}</Button>
          </a>
        )}
      </Card.Content>
    </Card>
  );
}

export default BalanceCard;
